import React from 'react';
import type { ImageSourcePropType } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { BodyText, Image, theme, useResponsive } from '@sg/garnish';

import { ChallengesScreenSectionHeader } from '../ChallengesScreenSectionHeader';

// ────────────────────────────────────────────────────────────────────────────────

export const ChallengesScreenInfoPanel = (
  props: ChallengesScreenInfoPanelProps,
) => {
  const { heading, text, illustrationSource, testID } = props;
  const { match } = useResponsive();

  const wrapperStyle = match([{}, styles.wrapperSM, styles.wrapperMD]);
  const illustrationStyle = match([
    styles.illustrationXS,
    styles.illustrationSM,
  ]);

  return (
    <View style={wrapperStyle} testID={testID}>
      <ChallengesScreenSectionHeader>{heading}</ChallengesScreenSectionHeader>
      <View style={styles.contentWrapper}>
        <Image
          source={illustrationSource}
          style={illustrationStyle}
          resizeMode="contain"
          accessibilityIgnoresInvertColors
        />

        <BodyText size={3} style={styles.bodyText}>
          {text}
        </BodyText>
      </View>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapperSM: {
    minHeight: 210,
  },
  wrapperMD: {
    minHeight: 214,
  },

  contentWrapper: {
    paddingTop: theme.spacing.large,
    alignItems: 'center',
  },

  illustrationXS: {
    width: 218,
    height: 128,
  },
  illustrationSM: {
    width: 220,
    height: 130,
  },

  bodyText: {
    textAlign: 'center',
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ChallengesScreenInfoPanelProps = {
  readonly heading: string;
  readonly text: string;
  readonly illustrationSource: ImageSourcePropType;
  readonly testID?: string;
};
